module.exports = __webpack_public_path__ + "assets/img/statis-done.0541c8a0.svg";